'use client';

import { type ElementType, forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { verticalNavHeadingStyles } from './styles/vertical-nav-heading.styles';
import type { VerticalNavHeadingPropsInterface } from './types/vertical-nav-heading.types';

/**
 * @since 10.0.0
 */
export const VerticalNavHeading = forwardRef<HTMLHeadingElement, VerticalNavHeadingPropsInterface>(
  (props: VerticalNavHeadingPropsInterface, forwardedRef) => {
    const { className, css: cssProp, level, ...rest } = props;

    const styles = css(verticalNavHeadingStyles, cssProp);

    const Component: ElementType = `h${level}`;

    return (
      <Component
        ref={forwardedRef}
        data-c11n-component="VerticalNav.Heading"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', 'c11n_vertical-nav__heading', styles, className)}
        {...rest}
      />
    );
  },
);

VerticalNavHeading.displayName = 'VerticalNav.Heading';
